export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    moreButton: {
      visible: true,
      text: 'Book your event',
    },
    scriptPath: widgetOpts.scriptPath,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;

      if (widgetCount == 0) {
        $(`.tier-3-container`).remove();
      } else {
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          let upperTitle =
            data.items[x].DetailLinkText.length >= 19
              ? data.items[x].DetailLinkText.substring(0, 19) + '...'
              : data.items[x].DetailLinkText;
          let mainTitle = data.items[x].Title;

          $(this)
            .find('.card-widget-title')
            .replaceWith(
              `<h1 class="main-title" aria-label="${upperTitle} ${mainTitle}"><span>${upperTitle}</span><span>${mainTitle}</span></h1>`,
            );

          $(this).find('.moreButton').addClass('button');
          $(this).find('.button').removeClass('moreButton');
          $(this).find('.button').removeAttr('target');
        });
      }
    },
  });
}
